export const WEB_SECTION_ORDER = [
  "button",
  "badge",
  "card",
  "modal",
  "dialog",
  "dropdown",
  "form",
  "input",
  "table",
  "datepicker",
  "paginated-table",
];

export const WEB_SECTION_DESCRIPTIONS: Record<string, string> = {
  button: "Current amazing_web button surface using Components/ui and the Tailwind wrapper.",
  badge: "Current badge primitive from Components/ui.",
  card: "Current web card surface, including the ui card and existing Tailwind card wrappers.",
  modal: "Current shared modal shell from Components/Common/Tailwind.",
  dialog: "Current confirm-pattern dialog usage. amazing_web still relies on useConfirmDialog and direct window.confirm usage.",
  dropdown: "Current dropdown primitives from Components/Common/Tailwind.",
  form: "Current shared form shell and grouping helpers from Components/Common/Tailwind.",
  input: "Current shared input/select/textarea primitives from Components/Common/Tailwind.",
  table: "Current shared table primitive from Components/Common/Tailwind.",
  datepicker: "Current shared CommonDatePicker wrapper used in modal-driven and date-change flows.",
  "paginated-table": "Current web paginated table variants: TableContainer and TableContainerNew.",
};

export const WEB_BUTTON_VARIANTS = [
  "primary",
  "secondary",
  "danger",
  "outline",
  "ghost",
];

export const WEB_BADGE_VARIANTS = [
  "primary",
  "success",
  "warning",
  "outline-primary",
  "soft-danger",
];

export const WEB_SAMPLE_ROWS = Array.from({ length: 24 }, (_, index) => ({
  id: index + 1,
  title: `Web Shared UI Row ${index + 1}`,
  category: index % 2 === 0 ? "Orders" : "Tickets",
  status: index % 3 === 0 ? "Live" : index % 3 === 1 ? "Draft" : "Paused",
  is_notice: index % 5 === 0,
}));

export const WEB_TABLE_COLUMNS = [
  { Header: "ID", accessor: "id" },
  { Header: "Title", accessor: "title" },
  { Header: "Category", accessor: "category" },
  { Header: "Status", accessor: "status" },
];
